import React, { Component } from 'react'
import { DatePicker } from 'antd'
import { graphql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { isEqual, get } from 'lodash'
import omitDeep from 'omit-deep-lodash'
import moment from 'moment'
import { getFullName } from '@sukiai/utils'
import {
  SET_AGENT_POSITION,
  SET_AGENT_SIZE,
  GET_AGENT_STATE,
  SET_AGENT_STATE,
  GET_AUDIO_STREAM_UI_CONTEXT,
  SET_AUDIO_STREAM_UI_CONTEXT,
  GET_DICTATION,
  SET_DICTATION,
  GET_MODAL,
  SET_MODAL,
  GET_SECTION,
  SET_SECTION,
  CLEAR_SECTION,
  GET_SECTIONS_TO_UPDATE,
  REMOVE_SECTION_TO_UPDATE,
  CLEAR_SECTIONS_TO_UPDATE,
  GET_VEIL,
  GET_SUBMISSION_STATUS,
  CLEAR_SUBMISSION_STATUS,
  GET_ADD_PB_SECTION,
  CLEAR_ADD_PB_SECTION,
  GET_CURRENT_COMPOSITION,
  GET_SOCKET_AUTHENTICATED,
  SET_CURRENT_COMPOSITION,
  GET_KEYBOARD_MODE,
  SET_KEYBOARD_MODE,
  GET_CURRENT_NOTETYPE_ID,
  GET_CURSOR_ACKNOWLEDGED,
  GET_SECTION_BEING_DELETED,
  GET_CONTENT_TO_INSERT
} from '../../apollo/actions'
import {
  GetCompositionById,
  UpdateComposition,
  CreateOrUpdatePatient,
  RefreshChartsData,
  SyncChartsData,
  QueryGetHCCSuggestions,
  GetNoteTypeById,
  GetScriptsByUserId
} from '@sukiai/gql/app'
import loSto from '../../config/loSto'
import seshSto from '../../config/seshSto'
import {
  LO_STO,
  SESH_STO,
  scrollToSection,
  HALF_STORY,
  recordNoteEvent,
  NOTE_EVENT_METRICS,
  setSignOffModal,
  setSubmitModal,
  getPbSectionCtx,
  deleteProblemSection,
  updatePbcSectionInCache,
  getExistingDiagnosis,
  isEmrUser,
  MODAL_STRINGS
} from '../../lib'
import {
  ActionPanel,
  Constants,
  Loading
} from '@sukiai/components'
import SidebarContainer from '../SidebarContainer'
import FunctionNoteContainer from './NoteContainer'
import { getCompositionById } from '../../recognition/ActionStream'
import { halfStory as hs, logger, logIntercomEvent } from '../../lib/logging'
import { sendSpeechConfig, getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import Section from './Section'
import PatientSearch from './Search'
import { FEATURE_FLAG, PICKERS, LOADING, MODAL_CONTENT, MODAL_ADDITIONAL_CONTENT } from './constants'
import GenderPicker from './components/GenderPicker/index'
import NoteInput from './components/NoteInput'
import AddProblemButton from './components/AddProblemButton'
import {
  stopSectionDictation,
  addProblemSection,
  createUpdateAttachOrCreatePatientRequest,
  createUpdateAppointmentRequest,
  play,
  isCerner,
  isAthena,
  isEpic,
  isInIframe,
  isAmwellTheme
} from '../../lib/util'
import { INTERCOM_EVENTS, FETCH_POLICY, ORG_IDS } from '../../lib/constants'
import HCCSuggestionsPanel from '../../components/HCCSuggestionsPanel'
import { isEnvironmentProd, isEnvironmentStage, isEnvironmentTest } from '../../config'
import { isEmrIntegrationToolBarVisible } from '../../helpers/emrIntegration'
import { fetchFeatureFlags } from '../../rest/featureFlags'

const { AGENT, SECTION_STATE, NOTE_STATUS, MODALS, SOUNDS } = Constants

class NoteContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      compositionData: props.compositionData,
      editableStates: {
        [PICKERS.DOS_PICKER]: false,
        [PICKERS.DOB_PICKER]: false,
        [PICKERS.GENDER_PICKER]: false,
        [PICKERS.MRN_INPUT]: false
      },
      isAddingProblem: false,
      hccSuggestions: [],
      notetypeDestinations: [],
      isNewPatientSelected: false
    }
  }

  componentWillMount () {
    const {
      location
    } = this.props

    fetchFeatureFlags()
      .then((res) => {
        const { flags = [] } = res
        const imoFlag = flags.find(flag => flag.key === FEATURE_FLAG.SUKI_FFBE_USE_IMO_2022_Q4)
        loSto.set(LO_STO.IS_IMO_POWERED, !!imoFlag?.enabled)
      })
      .catch((error) => {
        console.log('Error fetching feature flags', error)
      })

    window.addEventListener('beforeunload', this.unsetDocContext)

    const stream = getStreamWorker()

    const noteId = get(this.props, 'location.pathname', '').split('/')[2]

    // If noteId isnt there then dont send the event
    // Allowing to send the event even if there is no userId because SG relies
    // on noteId for doing anything
    if (noteId) {
      stream && stream.postMessage({
        cmd: DataCommand.DOC_ENTERED_NOTE,
        noteId,
        userId: loSto.get(LO_STO.USER_ID)
      })
    }

    loSto.set(LO_STO.CURRENT_COMP_ID, location.pathname.split('/')[2])
    loSto.remove(LO_STO.CURRENT_NOTE_ID)

    // Still recording this event just for our logs
    recordNoteEvent(NOTE_EVENT_METRICS.ENTERED, {
      noteId: loSto.get(LO_STO.CURRENT_COMP_ID),
      organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
      tabId: window.sessionStorage.TAB_ID
    })
  }

  async componentDidMount () {
    const {
      location,
      agentState,
      setAgentSize,
      setAgentPosition,
      clearSectionsToUpdate,
      compositionData,
      isSocketAuthenticated,
      keyboardMode,
      setAudioStreamContext,
      client
    } = this.props

    // get noteId
    const noteId = location.pathname.split('/')[2]
    const orgId = loSto.get(LO_STO.ORGANIZATION_ID)
    if (isSocketAuthenticated) {
      getCompositionById(noteId, orgId, 'Composition')
    }

    clearSectionsToUpdate('ENTERING NOTE')
    setAgentSize(AGENT.SIZE.SMALL)
    setAgentPosition(AGENT.POSITION.TOP_LEFT)

    if (compositionData) {
      this.setLocalStorageProps(compositionData)
      this.resyncChartsData()

      const noteTypeId = compositionData?.metadata?.noteTypeId
      if (noteTypeId) {
        client.mutate({
          mutation: GetNoteTypeById,
          variables: {
            organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
            id: noteTypeId
          }
        }).then(({ data }) => {
          const destinations = data?.noteTypes?.results?.[0]?.destinations
          this.setState({ notetypeDestinations: destinations })
        }).catch(err => {
          console.error('Unable to retrieve note type:', err)
        })

        setAudioStreamContext({
          noteId,
          noteTypeId,
          patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID) || '',
          problemBasedSections: await getPbSectionCtx(compositionData.id)
        }).then(() => {
          // restart audio to make sure noteId makes it to streaming-gateway
          sendSpeechConfig('User is viewing a note and new NoteID has been set')
        })

        if (isEmrUser()) {
          this.startSync(noteTypeId)
        }
      }
    }

    // If keyboardMode is false and agentState === MUTED, set it
    if (agentState === AGENT.STATE.MUTED && keyboardMode === false) {
      client.mutate({ mutation: SET_KEYBOARD_MODE })
      seshSto.session(SESH_STO.KEYBOARD_MODE, true)
      logger.info('[S2 ALERT - SETTING KEYBOARD_MODE FROM lLIENT - SINCE AGENT IS MUTED AND REFRESH HAPPENED]')
    }

    if (isInIframe) {
      window.parent.postMessage('suki-note-loaded', '*')
    }
  }

  startSync = (noteTypeId) => {
    const stream = getStreamWorker()
    const compositionId = get(this.props, 'location.pathname', '').split('/')[2]

    const refreshVitals = () => {
      stream && stream.postMessage({
        cmd: 'USER_REQUEST',
        userRequestType: 'CLICK_REFRESH_VITALS_ON_SCREEN',
        userRequestData: {
          compositionId,
          noteTypeId,
          patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID) || '',
          appointmentId: loSto.get(LO_STO.CURRENT_APPT_ID) || ''
        },
        ts: new Date().toISOString()
      })
    }

    refreshVitals()

    this.interval = setInterval(() => refreshVitals(), 1000)
  }

  componentDidUpdate (prevProps, prevState) {
    if (!prevProps.compositionData && this.props.compositionData) {
      if (isEmrUser()) {
        const notetypeId = this.props.compositionData?.metadata?.noteTypeId
        this.startSync(notetypeId)
      }
    }
  }

  async componentWillReceiveProps (nextProps) {
    const {
      location,
      audioStreamUIContext,
      setAudioStreamContext,
      updatedSubmissionStatus,
      clearSubmissionStatus,
      compositionData,
      client
    } = this.props

    if (nextProps.isSocketAuthenticated && !this.props.isSocketAuthenticated) {
      getCompositionById(
        location.pathname.split('/')[2],
        loSto.get(LO_STO.ORGANIZATION_ID),
        'Composition'
      )
    }

    if (nextProps.location.pathname !== location.pathname) {
      // set noteId for streaming-gateway's context object
      if (!audioStreamUIContext.noteId) {
        const compId = nextProps.location.pathname.split('/')[2]
        setAudioStreamContext({
          noteId: compId,
          patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID) || ''
        }).then(() => {
          // restart audio to make sure noteId makes it to streaming-gateway
          sendSpeechConfig('User is viewing a note and new NoteID has been set')
        })
      }
    }

    if (nextProps.compositionData && !this.props.compositionData) {
      const c = nextProps.compositionData
      const noteTypeId = c?.metadata?.noteTypeId

      setAudioStreamContext({
        noteId: c.id,
        patientId: c.metadata.patient?.id || '',
        problemBasedSections: await getPbSectionCtx(c.id),
        noteTypeId
      }).then(() => {
        // restart audio to make sure noteId makes it to streaming-gateway
        sendSpeechConfig('User is viewing a note and new NoteID has been set')
      })

      if (noteTypeId) {
        client.mutate({
          mutation: GetNoteTypeById,
          variables: {
            organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
            id: noteTypeId
          }
        }).then(({ data }) => {
          const destinations = data?.noteTypes?.results?.[0]?.destinations
          this.setState({ notetypeDestinations: destinations })
        }).catch(err => {
          console.error('Unable to retrieve note type:', err)
        })
      }

      this.resyncChartsData()
    }

    if (nextProps.compositionData && !isEqual(compositionData, nextProps.compositionData)) {
      const newSections = get(nextProps, 'compositionData.sectionsS2')
      if (newSections.length !== 0) {
        // weird caching error - this is the workaround
        this.setLocalStorageProps(nextProps.compositionData)
        this.setState({ compositionData: nextProps.compositionData })
      }

      const isNewPatientSelected = this.state.isAddingNewPatient
      if (isNewPatientSelected) {
        // Only if the patient is selected from the dropdown do we want to show this modal
        this.checkAppointmentDateAttached(get(nextProps.compositionData, 'metadata.appointment'))
        this.setState({ isAddingNewPatient: false })
      }
    }

    if (!updatedSubmissionStatus && nextProps.updatedSubmissionStatus) {
      this.setState(({ compositionData: oldCompData }) => ({
        compositionData: {
          ...oldCompData,
          metadata: {
            ...oldCompData.metadata,
            submissionStatus: nextProps.updatedSubmissionStatus
          }
        }
      }), clearSubmissionStatus)
    }

    if (nextProps.isAddingProblem && !this.props.isAddingProblem) {
      this.setState({ isAddingProblem: true })
    }

    if (nextProps.sectionBeingDeleted !== this.props.sectionBeingDeleted) {
      this.resyncChartsData()
    }

    // covers when patient has been added by voice
    const oldPatientId = get(this.props.compositionData, 'metadata.patient.id')
    const newPatientId = get(nextProps.compositionData, 'metadata.patient.id')
    if (oldPatientId !== newPatientId) {
      this.resyncChartsData()
    }
  }

  componentWillUnmount () {
    const {
      setAudioStreamContext,
      clearSection,
      dictation,
      clearSectionsToUpdate,
      client
    } = this.props

    clearInterval(this.interval)

    // we don't need to save to unfinished here since unsetDocContext will take care of this.

    client.mutate({
      mutation: SET_CURRENT_COMPOSITION,
      variables: {
        composition: ''
      }
    })

    this.unsetDocContext()
    window.removeEventListener('beforeunload', this.unsetDocContext)
    // clear noteId, noteTypeId and sectionId
    setAudioStreamContext({
      noteId: '',
      sectionId: '',
      noteTypeId: '',
      transcription: false,
      isScriptChange: false,
      patientId: '',
      problemBasedSections: []
    }).then(() => {
      sendSpeechConfig('Sending new speech configuration because leaving note.')
    })

    clearSection()
    clearSectionsToUpdate('LEAVING NOTE')

    if (dictation) {
      this.stopDictation()
    }

    loSto.remove(LO_STO.CURRENT_COMP_ID)
    loSto.remove(LO_STO.CURRENT_PATIENT_ID)
    loSto.remove(LO_STO.CURRENT_APPT_ID)
    loSto.remove(LO_STO.SUBMISSION_WARNING)
    loSto.remove(LO_STO.SUBMISSION_DESTINATIONS)
    loSto.remove(LO_STO.CURRENT_COMP_CREATED_WITH_S2)
    loSto.remove(LO_STO.CURRENT_COMPOSITION)
  }

  unsetDocContext = () => {
    const { compositionData } = this.props

    const noteId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const stream = getStreamWorker()
    const notetypeId = compositionData?.metadata?.noteTypeId
    const patientId = compositionData?.metadata?.patient?.id
    const appointmentId = compositionData?.metadata?.appointment?.id

    // To make sure we don't get error from S2, check if noteId is set
    if (noteId?.length > 0 && !loSto.get(LO_STO.SUBMISSION_SUCCESSFUL)) {
      hs.add(HALF_STORY.SAVE_COMP_TO_UNFINISHED, `Saving composition to unfinished. Comp ID [${noteId}]`)
      stream && stream.postMessage({
        cmd: 'USER_REQUEST',
        userRequestType: 'SAVE_COMPOSITION_TO_UNFINISHED',
        userRequestData: {
          compositionId: noteId,
          notetypeId: notetypeId,
          patientId: patientId,
          appointmentId: appointmentId
        },
        ts: new Date().toISOString()
      })
    } else {
      console.log('Issue unsetting doc context. noteId is empty')
    }

    // also reset SUBMISSION_SUCCESSFUL to null
    loSto.set(LO_STO.SUBMISSION_SUCCESSFUL, null)
    loSto.set(LO_STO.SUBMISSION_TRY_ALL_DESTINATION, null)

    // If noteId isnt there then dont send the event
    // Allowing to send the event even if there is no userId because SG relies
    // on noteId for doing anything

    if (noteId) {
      stream && stream.postMessage({
        cmd: DataCommand.DOC_LEFT_NOTE,
        noteId,
        userId: loSto.get(LO_STO.USER_ID)
      })
    }

    recordNoteEvent(NOTE_EVENT_METRICS.LEFT, {
      noteId: loSto.get(LO_STO.CURRENT_COMP_ID),
      organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
      tabId: window.sessionStorage.TAB_ID
    })
  }

  setLocalStorageProps = compData => {
    loSto.set(LO_STO.CURRENT_PATIENT_ID, get(compData, 'metadata.patient.id'))
    loSto.set(LO_STO.CURRENT_APPT_ID, get(compData, 'metadata.appointment.id'))
    loSto.set(LO_STO.SUBMISSION_WARNING, get(compData, 'metadata.submissionStatus.warning.type'))
    loSto.set(LO_STO.SUBMISSION_DESTINATIONS, get(compData, 'metadata.submissionInformation.destinations'))
    loSto.set(LO_STO.CURRENT_COMP_CREATED_WITH_S2, get(compData, 'metadata.createdWithS2'))
  }

  setCurrentSection = id => {
    const {
      setSection,
      dictation,
      setAudioStreamContext,
      currentSectionId,
      currentNotetypeId,
      keyboardMode
    } = this.props

    // IF USER IS IN DICTATION AND WE SWITCH SECTIONS
    if (dictation) {
      if (currentSectionId !== id && !keyboardMode) {
        hs.add(HALF_STORY.CHANGE_SECTION, `Sending CHANGE_SECTION. Section [${currentSectionId}] => [${id}]`)
        logger.info('SENDING CHANGE_SECTION FROM LINE 472 IN DICTATION MODE FROM NOTECONTAINER SETCURRENTSECTION FUNCTION')
        // send event to streamworker
        const stream = getStreamWorker()
        stream && stream.postMessage({
          cmd: DataCommand.USER_REQUEST,
          userRequestType: 'CHANGE_SECTION',
          userRequestData: {
            // WE SHOULD NOT SEND CHANGE_SECTION REQUEST IF SECTION_ID IS NULL
            sectionId: id
          },
          ts: new Date().toISOString()
        })
      }

      scrollToSection(id)
      setSection(id, SECTION_STATE.DICTATION)

      // We assume that dictation mode has silence detection off, unless wakeword is triggered
      setAudioStreamContext({
        transcription: true,
        sectionId: id,
        notetypeId: currentNotetypeId,
        patientId: ''
      }).then(() => {
        hs.add(HALF_STORY.VOICE, `Section Command Triggered on Section ID: ${id}`)
        logIntercomEvent(INTERCOM_EVENTS.USED_DICATION)
        sendSpeechConfig('Sending new speech configuration because sectionId changed.')
      })
    } else {
      scrollToSection(id, true)
      setSection(id, SECTION_STATE.FOCUSED)
    }
  }

  // If non-emr users are signing off, use this function
  handleSignOff = () => {
    const {
      dictation,
      setAgentSize,
      setAgentPosition
    } = this.props

    if (dictation) {
      this.stopDictation()
    } else {
      setAgentSize(AGENT.SIZE.SMALL)
      setAgentPosition(AGENT.POSITION.TOP_LEFT)
    }

    // TODO: Show modal to sign-off note & submit to patient notes
    setSignOffModal()
  }

  handleImDone = () => {
    const {
      dictation,
      setAgentSize,
      setAgentPosition,
      setModal
    } = this.props

    if (dictation) {
      this.stopDictation()
    } else {
      setAgentSize(AGENT.SIZE.SMALL)
      setAgentPosition(AGENT.POSITION.TOP_LEFT)
    }

    const currentCompId = loSto.get(LO_STO.CURRENT_COMP_ID)
    setSubmitModal(currentCompId)
  }

  stopDictation = (options) => {
    console.trace('stop dictation')
    const {
      setAudioStreamContext,
      agentState,
      compositionData,
      currentSectionId
    } = this.props

    hs.add(HALF_STORY.EXIT_DICTATION_BADGE_PRESSED, 'Sending EXIT_DICTATION_BADGE_PRESSED since we\'re stopping dictation')
    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'EXIT_DICTATION_BADGE_PRESSED',
      userRequestData: {
        compositionId: compositionData?.id,
        notetypeId: compositionData?.metadata?.noteTypeId
      },
      ts: new Date().toISOString()
    })

    setAudioStreamContext({
      agentAwake: false,
      transcription: false,
      isScriptChange: false,
      sectionId: '',
      patientId: ''
    }).then(() => {
      hs.add(HALF_STORY.VOICE, 'Stopping Dictation.')
      sendSpeechConfig('Sending new speech configuration on STOP_DICTATION.')
      // Also save to half story
      hs.save()
    })

    !options?.disableExitSound && play(SOUNDS.EXIT_DICTATION)
    // send agent state, should clear section, pass in currentSectionId

    stopSectionDictation(agentState, true, currentSectionId)
  }

  handleInputChange = () => {
    this.hasInputChanged = true
  }

  convertDate = date => {
    // this function converts the YYYY-MM-DD format to the MM/DD/YYYY format
    const convertedDate = date.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, function (match, y, m, d) {
      return m + '/' + d + '/' + y
    })
    return convertedDate
  }

  // Get the search component with the required props wrapped
  // When a search result is clicked, a backend call is made to get the appointment
  // and other metadata info related to the selected patient
  getSearchComponent = text => {
    const { compositionData } = this.state
    const hasPatient = !!compositionData?.metadata?.patient?.id
    const patientName = getFullName(compositionData?.metadata?.patient?.person)
    return (
      <PatientSearch
        handleUpdateComposition={patient => {
          this.getAppointmentAssociatedToPatient(patient, null, null, true)
        }}
        text={patientName || text}
        isFocused={!!text}
        isDisabled={hasPatient}
      />)
  }

  // Date of service picker in the note (in editable view)
  getSchedulePicker = dos => {
    const displayDOS = this.convertDate(dos)
    const pickerValue = moment(dos)

    return (
      <DatePicker
        format='MM/DD/YYYY'
        size='small'
        onChange={this.handleAppointmentCreation}
        autoFocus
        showToday={false}
        open
        defaultPickerValue={pickerValue}
        placeholder={displayDOS}
        onBlur={() => {
          this.setState(oldState => ({
            editableStates: {
              ...oldState.editableStates,
              [PICKERS.DOS_PICKER]: false
            }
          }))
        }}
      />
    )
  }

  // Date picker in the note (in editable view)
  getDobPicker = dob => {
    let displayDOB = 'MM/DD/YYYY'
    let pickerValue = moment()

    // if there is a dob, it displays the month of the dob in the overlay calendar
    if (dob !== 'Invalid date') {
      displayDOB = this.convertDate(dob)
      pickerValue = moment(dob)
    }

    return (
      <DatePicker
        format='MM/DD/YYYY'
        size='small'
        onChange={this.handleUpdatePatientDOBCreation}
        autoFocus
        open
        defaultPickerValue={pickerValue}
        placeholder={displayDOB}
        showToday={false}
        onBlur={() => {
          this.setState(oldState => ({
            editableStates: {
              ...oldState.editableStates,
              [PICKERS.DOB_PICKER]: false
            }
          }))
        }}
      />
    )
  }

  // Gender picker in the note (in editable view)
  getGenderPicker = gender => (
    <GenderPicker
      gender={gender}
      handleUpdatePatientGenderCreation={this.onUpdatePatientGenderCreation}
      onToggle={(field) => this.setEditableState(field)}
      dataCy='note-gender-picker'
    />
  )

  // Mrn input in the note (editable view)
  getMRNInput = val => (
    <NoteInput
      defaultValue={val}
      onChange={this.handleInputChange}
      onBlur={this.handleUpdatePatientMRNCreation}
      onToggle={(field) => this.setEditableState(field)}
      type='text'
      typeOfField={PICKERS.MRN_INPUT}
      dataCy='note-mrn-input'
    />
  )

  // Set/Unset the state to show/hide the pickers
  setEditableState = (field, isEditable) => {
    this.setState(oldState => ({
      editableStates: {
        ...oldState.editableStates,
        [field]: !!isEditable
      }
    }))
  }

  // Set the loading state to show the loader
  setLoadState = field => {
    this.setState(oldState => ({
      editableStates: {
        ...oldState.editableStates,
        [field]: LOADING
      }
    }))
  }

  // Function to create the appointment on the fly after the note is created
  handleAppointmentCreation = async (date) => {
    const format = 'YYYY-MM-DD'
    const formattedDate = moment(date._d).format(format)

    let startTime = moment().toISOString()
    let endTime = moment().add(30, 'm').toISOString()
    let isStartTimeValid = true

    const currentHour = moment().hour()
    startTime = moment(formattedDate).add(currentHour, 'h').toISOString()
    endTime = moment(formattedDate).add(currentHour, 'h').add(30, 'm').toISOString()
    isStartTimeValid = moment(formattedDate).isValid()
    const patient = get(this.state.compositionData, 'metadata.patient')
    const oldAppointment = get(this.state.compositionData, 'metadata.appointment')

    if (isStartTimeValid && patient?.id) {
      const appointment = {
        ...oldAppointment,
        patient,
        startsAt: startTime,
        endsAt: endTime
      }

      const compositionId = loSto.get(LO_STO.CURRENT_COMP_ID)
      const notetypeId = get(this.state.compositionData, 'metadata.noteTypeId')

      createUpdateAppointmentRequest({ appointment, compositionId, notetypeId })

      const newCompData = {
        ...this.state.compositionData
      }

      newCompData.metadata.appointment = appointment
      this.setState({ compositionData: newCompData })

      await this.props.client.mutate(
        {
          mutation: SET_CURRENT_COMPOSITION,
          variables: {
            composition: JSON.stringify(newCompData)
          },
          update: cache => {
            cache.writeQuery({
              query: GetCompositionById,
              variables: { id: newCompData.id },
              data: newCompData
            })
          }
        })
      this.setState(oldState => ({
        editableStates: {
          ...oldState.editableStates,
          [PICKERS.DOS_PICKER]: false
        }
      }))
    }
  }

  // When the dob of the patient is changed, update the patient's dob
  // by first calling the getPatientsByID api and then the update
  handleUpdatePatientDOBCreation = date => {
    this.getPatientsByIdAndUpdatePatient({ dateOfBirth: moment(date._d).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') }, PICKERS.DOB_PICKER)
  }

  // Once the gender is updated, update the patient's gender
  // by first calling the patientsByID api and then doing the update
  onUpdatePatientGenderCreation = event => {
    this.setEditableState(PICKERS.MRN_INPUT)
    this.getPatientsByIdAndUpdatePatient({ gender: event.target.value.toUpperCase() }, PICKERS.GENDER_PICKER)
  }

  handleUpdatePatientMRNCreation = event => {
    if (this.hasInputChanged) {
      this.setEditableState(PICKERS.MRN_INPUT)
      this.getPatientsByIdAndUpdatePatient({ mrn: event.target.value }, PICKERS.MRN_INPUT)
    }
    this.hasInputChanged = false
  }

  // Get the patient by the id and update the patient with the sent in info
  getPatientsByIdAndUpdatePatient = (updatedPersonOrPatientInfo, field) => {
    const currentPatient = get(this.state.compositionData, 'metadata.patient')
    const currentPerson = get(currentPatient, 'person')
    let updatedPatient = {}
    if (field === PICKERS.MRN_INPUT) {
      updatedPatient = {
        ...currentPatient,
        ...updatedPersonOrPatientInfo,
        person: { ...currentPerson }
      }
    } else {
      updatedPatient = {
        ...currentPatient,
        person: { ...currentPerson, ...updatedPersonOrPatientInfo }
      }
    }
    this.updatePatient(updatedPatient, field)
  }

  // Update the patient call and then find the best appointment for the updated
  // and latest patient and update the composition with all the latest info
  updatePatient = (patient, field) => {
    const newPatient = omitDeep(patient, '__typename')
    const { client } = this.props

    client.mutate({
      mutation: CreateOrUpdatePatient,
      variables: { ...newPatient }
    }).then(() => {
      console.info('Updated patient successfully')
      this.getAppointmentAssociatedToPatient(newPatient, null, field)
    }).catch(err => {
      console.error('Error updating patient info:', err)
    })
  }

  // Function to call the backend to get the best appointment
  // and other related metadata
  getAppointmentAssociatedToPatient = async (patient, appointmentId, field, isNewPatientSelected) => {
    const { client } = this.props
    const { compositionData } = this.state
    // const hasPatient = !!get(compositionData, 'metadata.patient.id')
    const requestType = isNewPatientSelected ? 'ATTACH_PATIENT' : 'UPDATE_PATIENT'

    createUpdateAttachOrCreatePatientRequest({
      requestType,
      compositionId: get(compositionData, 'id'),
      notetypeId: get(compositionData, 'metadata.noteTypeId'),
      patient,
      patientId: patient.id
    })

    const emrId = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.emr?.id
    const newCompData = {
      ...compositionData,
      metadata: {
        ...compositionData.metadata,
        patient,
        emrId
      }
    }

    await client.mutate({
      mutation: SET_CURRENT_COMPOSITION,
      variables: {
        composition: JSON.stringify(newCompData)
      },
      update: cache => {
        cache.writeQuery({
          query: GetCompositionById,
          variables: { id: newCompData.id },
          data: newCompData
        })
      }
    })

    this.setLocalStorageProps(newCompData)

    if (emrId) {
      const emrDepartmentId = get(newCompData, 'metadata.appointment.emrDepartmentId', '')
      const emrEncounterId = get(newCompData, 'metadata.appointment.emrEncounterId', '')
      this.refreshChartsData(
        loSto.get(LO_STO.CURRENT_PATIENT_ID),
        emrId,
        emrDepartmentId,
        emrEncounterId
      )
    }

    if (!newCompData.metadata.appointment && !emrId) {
      // If no appointment and non EMR then create an appointment for today
      this.setState({ compositionData: newCompData })
    } else {
      this.setState({ compositionData: newCompData })
      this.setEditableState(field)
    }

    this.setState({ isAddingNewPatient: true })
  }

  refreshChartsData = (patientId, emrId, emrDepartmentId, encounterEmrId) => {
    if (!patientId) return
    this.props.client.query({
      query: RefreshChartsData,
      variables: {
        patientId,
        emrId,
        emrDepartmentId,
        encounterEmrId
      },
      refetchQueries: [
        {
          query: GetCompositionById,
          variables: { id: loSto.get(LO_STO.CURRENT_COMP_ID) }
        }
      ]
    })
  }

  resyncChartsData = () => {
    const emrId = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.emr?.id
    if (emrId) {
      this.syncChartsData(loSto.get(LO_STO.CURRENT_PATIENT_ID))
    }
  }

  // other possible inputs (optional)
  // $emrPatientId: ID, $emrAppointmentDepartmentId: ID, emrEncounterId: ID, sukiAppointmentId
  // for problem suggestion panel
  syncChartsData = sukiPatientId => {
    const { compositionData } = this.props
    const emrEncounterId = get(compositionData, 'metadata.appointment.emrEncounterId')
    const emrAppointmentDepartmentId = get(compositionData, 'metadata.appointment.emrDepartmentId')
    const emrPatientId = get(compositionData, 'metadata.patient.mrn')
    const sukiAppointmentId = get(compositionData, 'metadata.appointment.id')
    const specialties = get(loSto.get(LO_STO.CURRENT_USER), 'specialties')

    if (!sukiPatientId) return
    this.props.client.mutate({
      mutation: SyncChartsData,
      variables: {
        sukiPatientId: sukiPatientId,
        emrEncounterId,
        emrAppointmentDepartmentId,
        sukiAppointmentId,
        emrPatientId
      }
    }).then(syncdData => {
      console.log('Synced Charts', syncdData)

      const sections = get(this.props, 'compositionData.sectionsS2', [])
      const existingDiagnoses = getExistingDiagnosis(sections)
      // getHCCSuggestions to store locally
      this.props.client.query({
        query: QueryGetHCCSuggestions,
        fetchPolicy: FETCH_POLICY.NETWORK_ONLY,
        variables: {
          patientId: sukiPatientId,
          existingDiagnoses,
          emrEncounterId,
          specialties
        }
      }).then(({ data }) => {
        this.setState({
          hccSuggestions: data?.getHCCSuggestions?.suggestions
        })
      })
    })
  }

  // Check the appointment date getting attached to the composition
  checkAppointmentDateAttached = appt => {
    if (get(appt, 'startsAt')) {
      const apptDate = moment(appt.startsAt)
      const today = moment()
      const diff = today.diff(apptDate, 'days')
      // If an old appointment gets attached compared to today's date then, show the
      // modal to just to make the user aware as to what has happened.
      const formattedAptDate = moment(apptDate).format('MMMM Do, YYYY')

      const hasEMR = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.emr?.id
      const MODAL_TEXT = hasEMR ? MODAL_CONTENT : `${MODAL_CONTENT}\n${MODAL_ADDITIONAL_CONTENT}`
      if (diff) {
        this.props.setModal({
          __typename: 'ModalContent',
          heading: `Setting Date of Service to ${formattedAptDate}`,
          body: MODAL_TEXT
        })
      }
    }
  }

  onAddProblem = async () => {
    const {
      compositionData
    } = this.state

    await addProblemSection(compositionData.id)
  }

  onDeleteProblemSection = sectionId => {
    const { setModal, dictation, currentSectionId, agentState } = this.props
    const { compositionData } = this.state

    if (dictation) {
      // send agent state, should clear section, pass in currentSectionId
      stopSectionDictation(agentState, true, currentSectionId)
    }

    setModal({
      __typename: 'ModalContent',
      type: MODALS.DELETE_SECTION,
      heading: 'Delete Problem?',
      body: 'Please confirm.',
      data: {
        __typename: 'ModalData',
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        compositionId: compositionData.id,
        sectionId: sectionId
      }
    })
  }

  onDeleteEmptyProblem = (sectionId) => {
    const { dictation, currentSectionId, agentState } = this.props

    if (dictation) {
      // send agent state, should clear section, pass in currentSectionId
      stopSectionDictation(agentState, true, currentSectionId)
    }
    deleteProblemSection(sectionId)
  }

  // FOR S2 send a USER_REQUEST of type UPDATE
  updateProblemSection = async (sectionId, name) => {
    const { compositionData } = this.props

    const sections = get(compositionData, 'sectionsS2')
    const section = sections.find(
      section => section.id === sectionId
    )

    const diagnosis = section?.diagnosisEntry?.diagnosis

    let sectionData

    if (diagnosis) {
      const diagnosisEntry = {
        ...section?.diagnosisEntry,
        diagnosis: {
          ...diagnosis,
          problemLabel: name
        }
      }
      sectionData = { ...section, name, diagnosisEntry }
    } else {
      sectionData = { ...section, name }
    }

    const compositionId = loSto.get(LO_STO.CURRENT_COMP_ID)
    const notetypeId = compositionData?.metadata?.noteTypeId

    logger.info(`Sending UPDATE_SECTION request for problem section: ${name} -> ${sectionId}`)
    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: 'USER_REQUEST',
      userRequestType: 'UPDATE_SECTION',
      userRequestData: {
        compositionId,
        sectionData,
        sectionId: sectionData?.id,
        notetypeId
      },
      ts: new Date().toISOString()
    })
    // possible fix for when locally it shows data that gets overwritten by newer updates.
    updatePbcSectionInCache(compositionData?.id, sectionData)

    return sectionData
  }

  renderSections = () => {
    const {
      currentSectionId,
      currentSectionState,
      setSection,
      updateComposition,
      removeSectionToUpdate,
      sectionsToUpdate,
      dictation,
      setAudioStreamContext,
      setAgentState,
      agentState,
      refetchComposition,
      cursorAcknowledged,
      scripts,
      contentToInsert
    } = this.props

    const { compositionData, isAddingProblem, hccSuggestions } = this.state

    const sectionsData = get(compositionData, 'sectionsS2', [])
    // Retrieves the index of the last PBN Section or Diagnosis Entry
    let idxToInsert = sectionsData
      .map(s => s.pbcSectionFlag || !!s.diagnosisEntry)
      .lastIndexOf(true)

    let diagnosisCount = 0

    const sections = get(compositionData, 'sectionsS2', []).map(s => {
      if (s.diagnosisEntry) {
        diagnosisCount++
      }

      let shouldUpdate = null
      if (cursorAcknowledged) {
        shouldUpdate = sectionsToUpdate.find(stu => stu.id === s.id)
      }

      const showSuggestionsPanel = currentSectionId === s.id && s.name === '' && this.state.hccSuggestions.length > 0

      const scriptsForThisSection = scripts
        ? scripts.filter(sc => {
          const scriptContainsSection = sc.blocks?.findIndex(b => {
            return b.sectionId === s.id || b.sectionId === ORG_IDS.SUKI
          }) > -1

          return scriptContainsSection
        })
        : []

      let sectionContentToInsert
      if (contentToInsert) {
        const parsedContent = JSON.parse(contentToInsert)
        if (parsedContent[ORG_IDS.SUKI]) {
          sectionContentToInsert = parsedContent[ORG_IDS.SUKI]
        } else if (parsedContent[s.id]) {
          sectionContentToInsert = parsedContent[s.id]
        }
      }

      return (
        <>
          <Section
            key={s.id}
            id={s.id}
            name={s.name}
            initialStatus={s.status}
            updateProblemSection={this.updateProblemSection}
            initialContent={s.content}
            isPbnSection={s.pbcSectionFlag}
            currentSectionId={currentSectionId}
            currentSectionState={currentSectionState}
            setSection={setSection}
            updateComposition={updateComposition}
            compositionId={compositionData.id}
            removeSectionToUpdate={removeSectionToUpdate}
            shouldUpdate={shouldUpdate}
            dictation={dictation}
            setAudioStreamContext={setAudioStreamContext}
            setAgentState={setAgentState}
            agentState={agentState}
            handleDeleteSection={this.onDeleteProblemSection}
            diagnosisCount={diagnosisCount}
            isProblemSection={!!s.diagnosisEntry}
            isNewSection={s.name === ''}
            section={s}
            sectionsData={sectionsData}
            refetchComposition={refetchComposition}
            stopDictation={this.stopDictation}
            deleteEmptyProblemSection={this.deleteEmptyProblemSection}
            scripts={scriptsForThisSection}
            contentToInsert={sectionContentToInsert}
          />
          {showSuggestionsPanel && <HCCSuggestionsPanel hccSuggestions={hccSuggestions} section={s} handleAddDiagnosis={this.resyncChartsData} />}
        </>
      )
    })

    if (idxToInsert !== -1) {
      // TODO: this is obsolete :/
      if (isAddingProblem) {
        sections.splice(
          idxToInsert + 1,
          0,
          <Section
            key='add-problem-section'
            id='add-problem-section'
            currentSectionId={currentSectionId}
            setSection={setSection}
            diagnosisCount={diagnosisCount}
            handleDeleteSection={this.onDeleteProblemSection}
            compositionId={compositionData.id}
            isNewSection
            isProblemSection
          />
        )
        idxToInsert++
      } else {
        sections.splice(idxToInsert + 1, 0, <AddProblemButton handleAddProblem={this.onAddProblem} key='add-problem-button' />)
      }
    }

    return sections
  }

  deleteEmptyProblemSection = (sectionId) => {
    const { dictation, currentSectionId, agentState } = this.props

    if (dictation) {
      // send agent state, should clear section, pass in currentSectionId
      stopSectionDictation(agentState, true, currentSectionId)
    }
    deleteProblemSection(sectionId)
  }

  isDosEditable = () => {
    const { compositionData, notetypeDestinations } = this.state

    if (!isEmrUser()) {
      return true
    }

    if (isAthena()) {
      return false
    }

    if (isCerner() || isEpic()) {
      if (notetypeDestinations?.includes('SUKI_ONLY')) {
        const appt = compositionData.metadata?.appointment
        if (appt) {
          const { id, emrId, emrEncounterId } = appt
          if (id === emrId && id === emrEncounterId && id !== null) {
            return true
          }
        }
      }

      return false
    }

    return false
  }

  handleIamDoneAfterEmrConnectionVerification = (isSignOff) => {
    const {
      setModal
    } = this.props
    if (isEmrIntegrationToolBarVisible()) {
      setModal({
        __typename: 'ModalContent',
        type: MODALS.NOTE_SUBMISSION_WITHOUT_EMR_CONNECTION,
        heading: MODAL_STRINGS.NOTE_SUBMISSION_WITHOUT_EMR_CONNECTION_HEADING,
        body: MODAL_STRINGS.NOTE_SUBMISSION_WITHOUT_EMR_CONNECTION_BODY
      })
      return
    }
    if (isSignOff) {
      this.handleSignOff()
      return
    }
    this.handleImDone()
  }

  render () {
    const {
      dictation,
      setDictation,
      modal,
      currentSectionId,
      veilActive,
      clearSection,
      sectionsToUpdate,
      currentSectionState,
      keyboardMode,
      client,
      agentState
    } = this.props

    const {
      compositionData,
      editableStates,
      notetypeDestinations
    } = this.state
    const sidebarSections = compositionData && compositionData.sectionsS2 && compositionData.sectionsS2.reduce((arr, s) => {
      const isNonPBN = !get(s, 'diagnosisEntry')
      if (isNonPBN) {
        arr.push({
          id: s.id,
          name: s.name,
          status: s.status,
          source: s.source
        })
      }

      return arr
    }, [])

    const patient = get(compositionData, 'metadata.patient')
    let newMetaData = {}
    let isSignOff = false

    const hasEMR = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)?.emr?.id

    const isCernerEMR = isCerner()
    if (compositionData) {
      newMetaData = {
        ...compositionData.metadata,
        hasEMR,
        isCernerEMR
      }

      if (!patient) {
        newMetaData = {
          ...newMetaData,
          patient: {
            mrn: null,
            patientId: null,
            person: {
              firstName: '',
              middleName: '',
              lastName: '',
              gender: '',
              dateOfBirth: ''
            }
          }
        }
      }

      // Non-EMR doctors can sign off notes with Suki
      isSignOff = get(newMetaData, 'status') === NOTE_STATUS.NEED_DOCTOR_SIGN_OFF
    }

    const currentSection = get(compositionData, 'sectionsS2', []).find((s) => s.id === currentSectionId)
    return (!compositionData) ? <Loading size={30} /> : (
      <div key='noteContainer-div'>
        <SidebarContainer
          modalType={modal.content.type}
          setCurrentSection={this.setCurrentSection}
          currentSectionId={currentSectionId}
          initialSections={sidebarSections}
          sectionsToUpdate={sectionsToUpdate}
          patient={compositionData?.metadata?.patient}
        />
        <FunctionNoteContainer
          sections={this.renderSections()}
          metadata={newMetaData}
          veilActive={veilActive}
          dictation={dictation}
          setDictation={setDictation}
          stopDictation={this.stopDictation}
          clearSection={clearSection}
          currentSectionState={currentSectionState}
          currentSection={currentSection}
          deleteEmptyProblemSection={this.deleteEmptyProblemSection}
          search={this.getSearchComponent}
          isDosEditable={this.isDosEditable()}
          schedulePicker={this.getSchedulePicker}
          dobPicker={this.getDobPicker}
          genderPicker={this.getGenderPicker}
          mrnInput={this.getMRNInput}
          editableStatesForPickers={editableStates}
          setEditableState={this.setEditableState}
          notetypeDestinations={notetypeDestinations}
          agentState={agentState}
        />
        {
          // TODO: Replace isAmwellTheme to a much more generic utility to handle all embed use cases in future
          (!isEnvironmentTest() && !isEnvironmentStage() && !isEnvironmentProd() && !isAmwellTheme()) &&
            <div key='keyboardMode-label' style={{ position: 'absolute', color: 'red', zIndex: 2 }}>
              {keyboardMode ? 'KEYBOARD MODE' : 'AUDIO MODE'}
            </div>
        }
        <ActionPanel
          isSignOff={isSignOff}
          title={isSignOff ? 'Sign off' : 'I\'m done'}
          handleImDone={() => this.handleIamDoneAfterEmrConnectionVerification(isSignOff)}
        />
      </div>
    )
  }
}

const mapScriptsToProps = ({ ownProps, data }) => ({
  errorScripts: data.error,
  loadingScripts: data.loading,
  scripts: data.macros && data.macros.results
})

export default compose(
  graphql(GetScriptsByUserId, {
    skip: props => !loSto.get(LO_STO.ORGANIZATION_ID) || !loSto.get(LO_STO.USER_ID),
    options: () => ({
      variables: {
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID),
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapScriptsToProps
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(GET_AGENT_STATE, {
    props: ({ data: { agentState } }) => ({
      agentState
    })
  }),
  graphql(SET_AGENT_STATE, {
    props: ({ mutate }) => ({
      setAgentState: agentState => mutate({
        variables: { agentState }
      })
    })
  }),
  graphql(SET_AUDIO_STREAM_UI_CONTEXT, {
    props: ({ mutate }) => ({
      setAudioStreamContext: context => mutate({
        variables: { audioStreamUIContext: context }
      })
    })
  }),
  graphql(GET_AUDIO_STREAM_UI_CONTEXT, {
    props: ({ data: { audioStreamUIContext } }) => ({
      audioStreamUIContext
    })
  }),
  graphql(GET_DICTATION, {
    props: ({ data: { dictation } }) => ({
      dictation
    })
  }),
  graphql(SET_DICTATION, {
    props: ({ mutate }) => ({
      setDictation: bool => mutate({
        variables: { dictation: bool }
      })
    })
  }),
  graphql(GET_MODAL, {
    props: ({ data: { modal } }) => ({
      modal
    })
  }),
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(GET_SECTION, {
    props: ({ data: { section: { id, state } } }) => ({
      currentSectionId: id,
      currentSectionState: state
    })
  }),
  graphql(SET_SECTION, {
    props: ({ mutate }) => ({
      setSection: (id, state) => mutate({
        variables: { id, state }
      })
    })
  }),
  graphql(CLEAR_SECTION, {
    props: ({ mutate }) => ({
      clearSection: () => mutate()
    })
  }),
  graphql(GET_SECTIONS_TO_UPDATE, {
    props: ({ data: { sectionsToUpdate } }) => ({
      sectionsToUpdate
    })
  }),
  graphql(GET_CURRENT_NOTETYPE_ID, {
    props: ({ data: { currentNotetypeId } }) => ({
      currentNotetypeId
    })
  }),
  graphql(REMOVE_SECTION_TO_UPDATE, {
    props: ({ mutate }) => ({
      removeSectionToUpdate: id => mutate({
        variables: { id }
      })
    })
  }),
  graphql(CLEAR_SECTIONS_TO_UPDATE, {
    props: ({ mutate }) => ({
      clearSectionsToUpdate: reason => mutate({
        variables: { reason }
      })
    })
  }),
  graphql(GET_VEIL, {
    props: ({ data: { veil } }) => ({
      veilActive: veil && veil.active
    })
  }),
  graphql(GET_SUBMISSION_STATUS, {
    props: ({ data: { submissionStatus } }) => ({
      updatedSubmissionStatus: submissionStatus
    })
  }),
  graphql(CLEAR_SUBMISSION_STATUS, {
    props: ({ mutate }) => ({
      clearSubmissionStatus: () => mutate()
    })
  }),
  graphql(GET_ADD_PB_SECTION, {
    props: ({ data: { addPbSection } }) => ({
      isAddingProblem: addPbSection
    })
  }),
  graphql(CLEAR_ADD_PB_SECTION, {
    props: ({ mutate }) => ({
      clearAddProblemSection: () => mutate()
    })
  }),
  graphql(GET_CURRENT_COMPOSITION, {
    props: ({ data: { composition } }) => ({
      compositionData: composition && JSON.parse(composition)
    })
  }),
  graphql(GET_SOCKET_AUTHENTICATED, {
    props: ({ data: { socket } }) => {
      return { isSocketAuthenticated: socket.isAuthenticated }
    }
  }),
  graphql(GET_KEYBOARD_MODE, {
    props: ({ data: { keyboardMode } }) => {
      return { keyboardMode }
    }
  }),
  graphql(GET_CURSOR_ACKNOWLEDGED, {
    props: ({ data: { cursorAcknowledged } }) => {
      return { cursorAcknowledged }
    }
  }),
  graphql(GET_SECTION_BEING_DELETED, {
    props: ({ data: { sectionBeingDeleted } }) => {
      return { sectionBeingDeleted }
    }
  }),
  graphql(GET_CONTENT_TO_INSERT, {
    props: ({ data: { contentToInsert } }) => {
      return { contentToInsert }
    }
  }),
  graphql(UpdateComposition, { name: 'updateComposition' }),
  withApollo,
  withRouter
)(NoteContainer)
